import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UrlBuilder } from '../core';
import { UserPermissionsStorage } from './user-permissions-storage';
import { PermissionName, UserPermissions } from './user-permissions';

@Injectable()
export class UserPermissionGuard implements CanActivate {

    constructor(private readonly permissionsStorage: UserPermissionsStorage, private readonly urlBuilder: UrlBuilder) { }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        const permission: PermissionName | PermissionName[] = route.data['permission'];

        if (!permission) {
            throw new Error('Pass the permission to the route.data');
        }

        return this.permissionsStorage.userPermissions
            .pipe(map(permissions => {
                if (this.hasPermissions(permissions, permission)) {
                    return true;
                } else {
                    this.urlBuilder.esa().navigate();
                    return false;
                }
            }));
    }

    private hasPermissions(allPermissions: UserPermissions, permission: PermissionName | PermissionName[]) {
        if (Array.isArray(permission)) {
            return permission.some(p => allPermissions.has(p));
        }
        return allPermissions.has(permission);
    }
}